/* eslint-disable no-irregular-whitespace */

function numberToChinese(num) {
  if (!num || isNaN(num)) return ''

  const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const bigUnits = ['', '拾', '佰', '仟', '万']
  const decUnits = ['角', '分']

  num = Number(num).toFixed(2)
  const [intStr, decStr] = num.split('.')
  let intNum = parseInt(intStr, 10)
  const jiao = parseInt(decStr[0], 10)
  const fen = parseInt(decStr[1], 10)

  let intPart = ''
  if (intNum === 0) {
    intPart = '零'
  } else {
    let idx = 0
    while (intNum > 0) {
      const n = intNum % 10
      if (n !== 0) {
        intPart = digits[n] + bigUnits[idx] + intPart
      } else if (intPart && !intPart.startsWith('零')) {
        intPart = '零' + intPart
      }
      intNum = Math.floor(intNum / 10)
      idx++
    }
  }

  let decPart = ''
  if (jiao > 0) decPart += digits[jiao] + decUnits[0]
  if (fen > 0) decPart += digits[fen] + decUnits[1]
  if (jiao === 0 && fen === 0) decPart = '整'

  return '人民币' + intPart + decPart
}

export function buildOrderPrintHtml(order) {
  if (!order) return ''

  const total = Number(order.total_amount || 0)
  const totalUpper = numberToChinese(total)

  const innerHtml = `
<div class="print-header">
  <h2>莲蓉园菜篮子发货单</h2>
</div>

<div class="print-info">
  <p>订单编号: ${order.order_number || ''}　　客户: ${order.customer_name || '未知客户'}　　单据日期: ${order.delivery_time || ''}</p>
</div>

<table class="print-table" cellpadding="3" cellspacing="0">
  <thead>
    <tr>
      <th style="min-width:45px;text-align:center;">序号</th>
      <th style="min-width:120px;text-align:center;">商品名称</th>
      <th style="min-width:70px;text-align:center;">规格</th>
      <th style="min-width:70px;text-align:center;">数量</th>
      <th style="min-width:75px;text-align:center;">单价</th>
      <th style="min-width:75px;text-align:center;">金额</th>
    </tr>
  </thead>
  <tbody>
    ${(order.items || []).map((item, index) => `
    <tr>
      <td style="text-align:center;">${index + 1}</td>
      <td style="text-align:center;">${item.merchandise_name || ''}</td>
      <td style="text-align:center;">${item.specification || '-'}</td>
      <td style="text-align:center;">${item.quantity || 0}</td>
      <td style="text-align:center;">${item.price != null ? Number(item.price).toFixed(2) : '0.00'}</td>
      <td style="text-align:center;">${item.amount != null ? Number(item.amount).toFixed(2) : '0.00'}</td>
    </tr>
    `).join('')}
  </tbody>
  <tfoot>
    <tr>
      <td colspan="5" style="text-align:center;font-weight:bold;">合计金额（大写）：${totalUpper}</td>
      <td style="text-align:center;font-weight:bold;">${total.toFixed(2)}</td>
    </tr>
  </tfoot>
</table>

<div class="print-footer">
  <p>制单人: ____________　　配送员: ____________　　客户签字: ____________</p>
</div>
  `

  return `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>莲蓉园发货单-${order.order_number || ''}</title>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "SimSun", serif;
  font-size: 9pt;
  padding: 6px;
  text-align: center;
}

.print-header h2 {
  text-align: center;
  margin: 4px 0 8px 0;
  font-size: 12pt;
  font-weight: bold;
}

.print-info {
  margin-bottom: 6px;
  line-height: 1.5;
  font-size: 9pt;
  text-align:center;
}

.print-table {
  /* 重点：auto，表格宽度跟随内容，不再撑满页面 */
  width: auto;
  border-collapse: collapse;
  margin:0 auto;
}

.print-table th,
.print-table td {
  border: 1px solid #000;
  padding: 2px 4px;
  font-size: 9pt;
  word-break: break-all;
}

.print-table th {
  font-weight: bold;
  background: #fff;
}

.print-footer {
  margin-top: 18px;
  line-height: 1.8;
  font-size: 9pt;
}

@page {
  size: auto;
  margin: 0.4cm;
}
</style>
</head>
<body>
${innerHtml}
</body>
</html>
`
}
